"use strict";
var _, r;
function t() {
  if (r) return _;
  r = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return _ = e, _;
}
export {
  t as __require
};
//# sourceMappingURL=index.es525.js.map
